<template>
  <div class="emails">
    <template
      v-if="
        currentDepartment.rol_name == 'superuser' &&
          $route.params.pathName == 'myQueue'
      "
    >
      <PageNotAllowed :busy="false" />
    </template>
    <template
      v-else-if="
        currentDepartment.department_id != 1 &&
          $route.params.pathName == 'hypercubes'
      "
    >
      <PageNotAllowed :busy="false" />
    </template>
    <template
      v-else-if="
        currentDepartment.rol_name != 'superuser' &&
          $route.params.pathName == 'alerts' &&
          currentDepartment.department_id !== 1
      "
    >
      <PageNotAllowed :busy="false" />
    </template>
    <template v-else>
      <template
        v-if="
          $store.getters['login/showUserLoggedIn'][0].is_busy &&
            ($route.params.pathName == 'queue' ||
              $route.params.pathName == 'spanish-queue')
        "
      >
        <PageNotAllowed :busy="true" />
      </template>
      <template v-else>
        <template
          v-if="
            currentDepartment.rol_name == 'superuser' &&
              $route.params.pathName == 'alerts' &&
              currentDepartment.department_id == 1
          "
        >
          <h1>
            <b
              >{{ currentDepartment.department_name.toUpperCase() }} Alerts ({{
                totalQuotes
              }})</b
            >
          </h1>
        </template>
        <template
          v-if="
            $route.params.pathName == 'hypercubes' &&
              currentDepartment.department_id == 1
          "
        >
          <h1>
            <b
              >{{ currentDepartment.department_name.toUpperCase() }} Hypercubes
              ({{ totalQuotes }})</b
            >
          </h1>
        </template>
        <template v-if="$route.path === '/myQueue'">
          <h1>
            <b v-if="currentDepartment.department_id == 2"
              >My
              {{ actualQueueName === "FTL" ? "OTR" : actualQueueName }} Queue
              ({{ totalQuotes }})
            </b>
            <b v-else
              >My {{ currentDepartment.department_name.toUpperCase() }} Queue
              ({{ totalQuotes }})</b
            >
          </h1>
        </template>
        <template v-if="$route.path === '/queue'">
          <h1>
            <b v-if="currentDepartment.department_id == 2"
              >{{ actualQueueName === "FTL" ? "OTR" : actualQueueName }} Queue
              ({{ totalQuotes }})
            </b>
            <b v-else
              >{{ currentDepartment.department_name.toUpperCase() }} Queue ({{
                totalQuotes
              }})</b
            >
          </h1>
        </template>
        <template v-if="$route.path === '/spanish-queue'">
          <h1>
            <b
              >{{ currentDepartment.department_name.toUpperCase() }} Spanish -
              Queue ({{ totalQuotes }})</b
            >
          </h1>
        </template>
        <template v-if="$route.path === '/failed'">
          <h1>
            <b v-if="currentDepartment.department_id == 2"
              >{{ actualQueueName === "FTL" ? "OTR" : actualQueueName }} Failed
              ({{ totalQuotes }})
            </b>
            <b v-else
              >{{ currentDepartment.department_name.toUpperCase() }} Failed ({{
                totalQuotes
              }})</b
            >
          </h1>
        </template>
        <template v-if="$route.path === '/inProcess'">
          <h1>
            <b v-if="currentDepartment.department_id == 2"
              >{{ actualQueueName === "FTL" ? "OTR" : actualQueueName }} In
              Process ({{ totalQuotes }})
            </b>
            <b v-else
              >{{ currentDepartment.department_name.toUpperCase() }} In Process
              ({{ totalQuotes }})</b
            >
          </h1>
        </template>
        <template v-if="$route.path === '/sent'">
          <h1>
            <b v-if="currentDepartment.department_id == 2"
              >{{ actualQueueName === "FTL" ? "OTR" : actualQueueName }} Sent
              ({{ totalQuotes }})
            </b>
            <b v-else
              >{{ currentDepartment.department_name.toUpperCase() }} Sent ({{
                totalQuotes
              }})</b
            >
          </h1>
        </template>
        <template v-if="$route.path === '/unknown'">
          <h1>
            <b v-if="currentDepartment.department_id == 2"
              >Non {{ actualQueueName }} ({{ totalQuotes }})
            </b>
            <b v-else
              >Non {{ currentDepartment.department_name.toUpperCase() }} ({{
                totalQuotes
              }})</b
            >
          </h1>
        </template>
        <template v-if="$route.path === '/deleted'">
          <h1>
            <b v-if="currentDepartment.department_id == 2"
              >{{ actualQueueName === "FTL" ? "OTR" : actualQueueName }} Deleted
              ({{ totalQuotes }})
            </b>
            <b v-else
              >{{ currentDepartment.department_name.toUpperCase() }} Deleted ({{
                totalQuotes
              }})</b
            >
          </h1>
        </template>
        <hr />

        <ListTable aria-label="List of pending quotes" />
      </template>
    </template>
  </div>
</template>

<script>
import ListTable from "./ListTable";
import PageNotAllowed from "@/components/PageNotAllowed";
import { validateRoutes } from "@/mixins/infoEmail/validateQuote";
import { mapGetters, mapState } from "vuex";

export default {
  name: "Emails",
  components: {
    ListTable,
    PageNotAllowed
  },
  data() {
    return {
      items: null,
      isBusy: false,
      currentDepartment: null,
      actualQueueName: null,
      autoassignerWebsocketOn: false
    };
  },
  computed: {
    ...mapState({
      login: state => state.login.userLoggedIn,
      totalQuotes: state => state.quotes.totalQuotes
    }),
    ...mapGetters("login", ["showInfoDepartment"]),
    ...mapGetters("quotes", ["showActualQueue"])
  },
  watch: {
    showInfoDepartment(value) {
      this.currentDepartment = value;
      if (this.currentDepartment.department_id == 2) {
        this.getQueueName(this.showActualQueue);
      }
      this.routeValidation();
    },
    showActualQueue() {
      this.getQueueName(this.showActualQueue);
    },
    async $route() {
      this.routeValidation();
      this.notificationAutoassignerSocket();
    }
  },
  beforeMount() {
    this.items = this.$store.getters.showItems;
    this.currentDepartment = this.showInfoDepartment;
    this.routeValidation();
    this.notificationAutoassignerSocket();
    if (this.currentDepartment.department_id == 2) {
      localStorage.setItem("actual-queue", this.showActualQueue);
      this.getQueueName(this.showActualQueue);
    }
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  destroyed() {
    this.closeNotificationAutoassignerSocket();
  },
  methods: {
    getQueueName(name) {
      switch (name) {
        case "ftl":
          this.actualQueueName = "FTL";
          break;
        case "drayage":
          this.actualQueueName = "Drayage";
          break;
      }
    },
    routeValidation() {
      const routes = ["myQueue", "queue", "alerts", "failed", "spanish-queue"];
      const validation = validateRoutes(routes, this.$route?.params?.pathName);
      if (validation) {
        this.getAutoassignerInfo();
      }
    },
    async getAutoassignerInfo() {
      if (this.currentDepartment?.department_id === 1) {
        const params = {};
        params.skip = 0;
        params.limit = 100;
        await this.$store.dispatch(
          "usersManagement/autoassigner/getAutoassignerInfo",
          params
        );
      }
    },
    async notificationAutoassignerSocket() {
      const isUserBusy = JSON.parse(
        localStorage.getItem("charlie-username-otr")
      )[0]?.is_busy;
      const validateRouteAndDto =
        this.$route?.params?.pathName === "myQueue" &&
        this.currentDepartment?.department_id === 1;
      if (validateRouteAndDto && !isUserBusy) {
        await this.$store.dispatch(
          "usersManagement/autoassigner/notificationAutoassignerSocket"
        );
        this.autoassignerWebsocketOn = true;
      }
      this.closeNotificationAutoassignerSocket();
    },
    closeNotificationAutoassignerSocket() {
      if (
        this.$route?.params?.pathName !== "myQueue" &&
        this.autoassignerWebsocketOn
      ) {
        this.autoassignerWebsocketOn = false;
        this.$store.commit(
          "usersManagement/autoassigner/closeDataUsersSocketListener"
        );
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@include h1-font-size;

.emails {
  min-height: $view-height;
  @include padding-view(1%);
}
</style>
